import * as React from 'react';

import { Api } from '../typings/api';
import Utils from './index';
import { DriveItemInfoMap } from '../containers/DriveItemList/reducer';
import { ThumbMap } from '../containers/OfflineManager/reducer';

const isSvgIcon = (iconSrc: string): boolean => iconSrc.includes('iconset');

export const getMenuButtonIconSrc = (
	icon = '',
	driveItems: DriveItemInfoMap,
	config: Api.Config,
	thumbMap: ThumbMap,
	resolutions: { [k: string]: Api.ResolutionGroup },
): string => {
	if (isSvgIcon(icon)) {
		return icon;
	}

	let imageSrc = '';
	const iconId = icon && Utils.getMediaId(icon);

	if (iconId && iconId > -1 && driveItems[iconId]) {
		imageSrc = Utils.getCustomIconUrl(config, thumbMap, driveItems[iconId], resolutions);
	}

	return imageSrc;
};

export const getMenuButtonIcon = (iconSrc?: string, defaultIcon?: string): React.ReactNode => {
	if (!iconSrc) {
		return defaultIcon
			? Utils.getSvgIcon(defaultIcon)
			: null;
	}

	return isSvgIcon(iconSrc)
		? Utils.getSvgIcon(iconSrc)
		: <img src={iconSrc} />;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/menuManager.tsx